import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ActionBarPortalState } from './action-bar-portal.models';

export const actionBarPortalFeatureKey = 'actionBarPortal';

export const selectActionBarPortalState = createFeatureSelector<ActionBarPortalState>(actionBarPortalFeatureKey);

export const selectActionBarPortal = createSelector(selectActionBarPortalState, (state) => state?.portal ?? null);

export const selectForceActionBarLayoutClass = createSelector(
  selectActionBarPortalState,
  (state) => state?.forceLayoutClass ?? false,
);
